import React from 'react';
import {Navigate} from 'react-router-dom';
import {sezioneAccesa} from '../../moduli/leggi';
import {useSkin} from '../../moduli/useSkin';

/**
 * La porta di una sezione: se la skin l'ha spenta, l'indirizzo rimanda alla
 * Home invece di mostrare una pagina che nel menu non c'e'. Vale per Sport,
 * Live sport, Casino', Live casino, Poker, Virtual, con le chiavi del
 * catalogo (skin.sections).
 */
export default function SeSezione({chiave, children}) {
  useSkin();
  if (!sezioneAccesa(chiave)) return <Navigate to={'/'} replace/>;
  return children;
}
